var React = require('react');

function Users (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#151515","strokeWidth":"1.333"},[React.createElement("path",{"d":"m5.5 10a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5z","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"m9.713 3.62a3.25 3.25 0 1 1 .882 6.38m-9.595 2.337a5.501 5.501 0 0 1 9 0m.595-2.337a5.493 5.493 0 0 1 4.5 2.337","strokeLinecap":"round","strokeLinejoin":"round","key":1})]));
}

Users.defaultProps = {"fill":"none","height":"16","viewBox":"0 0 16 16","width":"16"};

module.exports = Users;

Users.default = Users;
